import { render, staticRenderFns } from "./BusinessRuleRow.vue?vue&type=template&id=4f8aeb64&scoped=true&lang=pug&"
import script from "./BusinessRuleRow.vue?vue&type=script&lang=js&"
export * from "./BusinessRuleRow.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRuleRow.vue?vue&type=style&index=0&id=4f8aeb64&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8aeb64",
  null
  
)

export default component.exports